import { z } from 'zod';

/**
 * "Check all models" runs in the background (BS: POST /models/refresh used to probe ~69 models inside the request
 * and hit the 60 s proxy timeout, saving nothing). POST starts a run (or returns the one already running) with 202;
 * GET /models/refresh/status reports progress. Each model's result is saved as soon as its check finishes.
 */
export const ModelRefreshError = z.object({ modelId: z.string(), error: z.string() });
export const ModelRefreshStatus = z.object({
  runId: z.string().uuid().nullable(),
  /** none = never checked; running; ok = finished (some models may still not work); failed = the run itself stopped. */
  status: z.enum(['none', 'running', 'ok', 'failed']),
  /** true on POST when a run was already going and no new one was started (single-flight). */
  alreadyRunning: z.boolean().optional(),
  done: z.number().int().min(0),
  total: z.number().int().min(0).nullable(),
  working: z.number().int().min(0),
  notWorking: z.number().int().min(0),
  gone: z.number().int().min(0).nullable(),
  startedAt: z.string().nullable(),
  finishedAt: z.string().nullable(),
  /** Per model: why it could not be used, or why its result could not be saved. */
  errors: z.array(ModelRefreshError),
  /** Why the whole run failed (listing Bedrock failed, server restarted mid-run, ...). */
  error: z.string().nullable(),
});
export type ModelRefreshStatus = z.infer<typeof ModelRefreshStatus>;
